import { render, staticRenderFns } from "./bilibili_video.vue?vue&type=template&id=e65316c4"
import script from "./bilibili_video.vue?vue&type=script&lang=js"
export * from "./bilibili_video.vue?vue&type=script&lang=js"
import style0 from "./bilibili_video.vue?vue&type=style&index=0&id=e65316c4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports